import { Stack } from "@mui/material";
import React from "react";

import { ArrowSelectorIcon, Circle, CropSquare, DiagonalArrow, InkEraserIcon, InsertTextIcon, LineIcon } from "assets/icons";
import { GroundlightButton } from "new-components/buttons/GroundlightButton";
import { IconType } from "types/icons";

import { StrokeSettings, StrokeWidth } from "./StrokeSettings/StrokeSettings";

export type AnnotatorTool = "selector" | "arrow" | "line" | "circle" | "rectangle" | "text" | "eraser";

type Tool = {
  tool: AnnotatorTool;
  icon: IconType;
};

const tools: Tool[] = [
  {
    tool: "selector",
    icon: ArrowSelectorIcon,
  },
  {
    tool: "arrow",
    icon: DiagonalArrow,
  },
  {
    tool: "line",
    icon: LineIcon,
  },
  {
    tool: "circle",
    icon: Circle,
  },
  {
    tool: "rectangle",
    icon: CropSquare,
  },
  {
    tool: "text",
    icon: InsertTextIcon,
  },
  {
    tool: "eraser",
    icon: InkEraserIcon,
  },
];

export type AnnotatioToolSettings = {
  tool: AnnotatorTool;
  strokeWidth: StrokeWidth;
  strokeColor: string;
};

type AnnotatorToolsProps = {
  settings: AnnotatioToolSettings;
  onChange: (settings: AnnotatioToolSettings) => void;
};

export function AnnotatorTools({ settings, onChange }: AnnotatorToolsProps) {
  const handleToolChange = (tool: AnnotatorTool) => {
    onChange({
      ...settings,
      tool,
    });
  };

  return (
    <Stack
      gap="15px"
      height="100%"
      sx={{
        background: "#E5E9ED",
        padding: "10px",
      }}
    >
      {tools.map(({ tool, icon: Icon }) => {
        const isSelected = tool === settings.tool;

        return (
          <GroundlightButton
            key={tool}
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "5px",
              background: isSelected ? "#A3D1F7" : undefined,
            }}
            iconColor={isSelected ? "#006DD9" : "#000000"}
            endIcon={Icon}
            onClick={() => {
              handleToolChange(tool);
            }}
            variant="plain"
          />
        );
      })}

      <StrokeSettings
        color={settings.strokeColor}
        width={settings.strokeWidth}
        onColorChange={(color) =>
          onChange({
            ...settings,
            strokeColor: color,
          })
        }
        onWidthChange={(width) =>
          onChange({
            ...settings,
            strokeWidth: width,
          })
        }
      />
    </Stack>
  );
}
